export interface LogMessage {
  type: 'log' | 'warn' | 'error';
  message: string;
  environment: string;
  version: string;
  context: Record<string, unknown>;
}

export enum TrackType {
  TRACK_EVENT = 'event',
  TRACK_PAGEVIEW = 'pageview',
}

export type TrackBody =
  | TrackPageview
  | TrackEvent
  | (TrackEvent & TrackUserProperties);

export interface TrackPageview {
  link: string;
}

interface TrackEvent {
  events: Event[];
}

interface Event {
  name: string;
  params:
    | TrackEntity
    | TrackAddToVacancy
    | TrackChangeStatus
    | TrackCheckPacketPrice
    | TrackClickOnContact
    | TrackOpenPlugin
    | TrackTrialActivation;
}

interface ExtraOptions {
  engagement_time_msec: number;
}

interface TrackEntity {
  profileId: string;
  recruiterId: number;
}

interface TrackAddToVacancy extends TrackEntity {
  vacancyId: number;
}

interface TrackChangeStatus extends TrackEntity {
  statusId: number;
  vacancyId: number;
}

interface TrackCheckPacketPrice {
  recruiterId: number;
}

interface TrackClickOnContact extends TrackEntity {
  source: string;
}

interface TrackOpenPlugin extends TrackEntity, ExtraOptions {
  link: string;
  location: string;
}

interface TrackTrialActivation {
  recruiterId: number;
}

interface TrackUserProperties {
  user_id: string;
  user_properties: {
    [key: string]: {
      value: string;
    };
  };
}
